document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".tab-button");
  const tabContents = document.querySelectorAll(".tab-content");

  tabButtons.forEach(button => {
    button.addEventListener("click", function () {
      const tabId = this.getAttribute("data-tab");

      tabButtons.forEach(btn => btn.classList.remove("active"));
      tabContents.forEach(tab => tab.classList.remove("active"));

      this.classList.add("active");
      const activeTab = document.getElementById(tabId);
      activeTab.classList.add("active");

      setupInputs(tabId);
    });
  });

  
  function setupInputs(tabId) {
    const index = tabId.replace("tab", "");
    // Common helper
    function formatNumber(num) {
      return parseFloat(num).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }
  
    if (index == "1") {
      // ---------------------------- INDEX 1 LOGIC ----------------------------
      const avgPrice = document.getElementById(`avgPrice${index}`);
      const packagingPrice = document.getElementById(`packagingPrice${index}`);
      const lbsProduced = document.getElementById(`lbsProduced${index}`);
      const yieldInput = document.getElementById(`yieldInput${index}`);
      const sqftGrow = document.getElementById(`sqftGrow${index}`);
      const packCost = document.getElementById(`packCost${index}`); // pack cost
  
      const rhGainId = document.getElementById(`rhGain${index}`);
      const rhGainTwoId = document.getElementById(`rhGainTwo${index}`);
      const gramsPerPoundId = document.getElementById(`gramsPerPound${index}`);
      const mylarWeightId = document.getElementById(`mylarWeight${index}`);
      const rhtreatWeightId = document.getElementById(`rhtreatWeight${index}`);
      const terplocWeightId = document.getElementById(`terplocWeight${index}`);
  
      const avgPriceValue = document.getElementById(`avgPriceValue${index}`); // 7.5
      const packagingPriceValue = document.getElementById(`packagingPriceValue${index}`); // 2.0
      const lbsProducedValue = document.getElementById(`lbsProducedValue${index}`); // 15000
  
      const revenueDisplay = document.getElementById(`revenue${index}`);
      const wasteDisplay = document.getElementById(`waste${index}`);
  
      function getTierFactor(fieldname23) {
        if (fieldname23 < 3) return 2.5;
        if (fieldname23 < 6) return 2.38;
        if (fieldname23 < 12) return 2.25;
        if (fieldname23 < 25) return 2.13;
        if (fieldname23 < 50) return 2.0;
        if (fieldname23 < 200) return 1.88;
        if (fieldname23 >= 200) return 1.69;
        // return 1.69;
      }
  
      function updateValues() {
        avgPriceValue.textContent = avgPrice.value;
        packagingPriceValue.textContent = packagingPrice.value;
        lbsProducedValue.textContent = parseInt(lbsProduced.value).toLocaleString();
  
        const pricePerGram = parseFloat(avgPrice.value) || 0; // 7.5
        const packagingCost = parseFloat(packagingPrice.value) || 0; // 2.0
        const poundsProduced = parseFloat(lbsProduced.value) || 0; // 15000
        const yieldValue = parseFloat(yieldInput.value) || 1;
        
        const gramsPerPound = parseFloat(gramsPerPoundId.value); // 453.592
        const factor26 = parseFloat(rhGainId.value); // 0.12
        const factor27 = parseFloat(rhGainTwoId.value); // 1.8333333
  
        const fieldname28 = parseFloat((factor27 * factor26 * 100 * poundsProduced) / 1000);
        const fieldname29 = parseFloat(poundsProduced + Math.round((fieldname28)));
  
        const f30 = parseFloat(pricePerGram * gramsPerPound * fieldname29);

        const f22 = parseFloat(getTierFactor(poundsProduced/100));

        const f24 = parseFloat(f22 * poundsProduced);

        const f19 = parseFloat(pricePerGram * poundsProduced * gramsPerPound);
        
        const f51= parseFloat(f30-f24-f19);

        const f45 = parseFloat(packagingCost * poundsProduced);

        const f46 = parseFloat(packCost.value);
        const f47 = parseFloat(f46 * poundsProduced);

        const f48 =  parseFloat(f45 + f47)

        const f50 = parseFloat(f30- f48 - f19);

        const revenueInDollars = parseFloat(f51 - f50);

        const estimatedSqft = yieldValue !== 0 ? Math.round(poundsProduced / yieldValue) : 0;
        
  
        const mylarWeightValue = mylarWeightId.value;
        const rhtreatWeightValue = rhtreatWeightId.value;
        const terplocWeightIdValue = terplocWeightId.value;
  
        const fieldname58 = poundsProduced * mylarWeightValue;
        const fieldname60 = poundsProduced * rhtreatWeightValue;
        const fieldname61 = fieldname58 + fieldname60;
        const fieldname62 = fieldname61 / gramsPerPound;
        const fieldname63 = terplocWeightIdValue * poundsProduced;
        const fieldname64 = fieldname63 / gramsPerPound;
        const savings = fieldname62 - fieldname64;

        sqftGrow.value = estimatedSqft.toLocaleString();
        revenueDisplay.textContent = `${formatNumber(revenueInDollars)}`;
        wasteDisplay.textContent = `${formatNumber(savings)}`;
      }
  
      [
        avgPrice,
        packagingPrice,
        lbsProduced,
        yieldInput,
        rhGainId,
        rhGainTwoId,
        gramsPerPoundId,
        mylarWeightId,
        rhtreatWeightId,
        terplocWeightId
      ].forEach((input) => {
        input.removeEventListener("input", updateValues);
        input.addEventListener("input", updateValues);
      });
  
      updateValues();
    }
    else if (index == "2") {
      const price = document.getElementById(`avgPrice${index}`);            
      const packaging = document.getElementById(`packagingPrice${index}`);  
      const output = document.getElementById(`lbsProduced${index}`);        
      const gramsPerPound = document.getElementById(`gramsPerPound${index}`); 
      const yieldInput = document.getElementById(`yieldInput${index}`);

      const mylarWeightId = document.getElementById(`mylarWeight${index}`);
      const rhtreatWeightId = document.getElementById(`rhtreatWeight${index}`);
      const terplocWeightId = document.getElementById(`terplocWeight${index}`);

      // const packCostId = document.getElementById(`packCost${index}`);
      const rhGainId = document.getElementById(`rhGain${index}`);
      const rhGainTwoId = document.getElementById(`rhGainTwo${index}`);
    
      const revenueDisplay = document.getElementById(`revenue${index}`);
      const wasteDisplay = document.getElementById(`waste${index}`);
      const growFootprint = document.getElementById(`sqftGrow${index}`); 
    
      function formatNumber(num) {
        return parseFloat(num).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
    
      function updateValues() {
        const avgPriceValue = document.getElementById(`avgPriceValue${index}`);
        const packagingPriceValue = document.getElementById(`packagingPriceValue${index}`);
        const lbsProducedValue = document.getElementById(`lbsProducedValue${index}`);
        
        avgPriceValue.textContent = price.value;
        packagingPriceValue.textContent = packaging.value;
        lbsProducedValue.textContent = parseInt(output.value).toLocaleString();
    
        // Parse inputs
        const lbsProduced = parseFloat(output.value) || 0;
        const gPerLb = parseFloat(gramsPerPound.value) || 453.592;
        const avgPrice = parseFloat(price.value) || 0;
        const packagingPrice = parseFloat(packaging.value) || 0;
        const yieldVal = parseFloat(yieldInput.value) || 0;
    
        // WP fields
        const field26 = rhGainId.value // 0.12;
        const field27 = rhGainTwoId.value // 1.8333333;
    
        // Revenue Calculation
        const extraLbs = (field27 * field26 * 100 * lbsProduced) / 1000;
        const totalLbs = lbsProduced + extraLbs;
        const grossRevenue = avgPrice * gPerLb * totalLbs;
        const totalPackagingCost = packagingPrice * lbsProduced;
        const totalInitialRevenue = avgPrice * lbsProduced * gPerLb;
        const revenue = grossRevenue - (totalInitialRevenue - totalPackagingCost);
        
        // ✅ sqftGrow calculation
        const sqftGrow = yieldVal !== 0 ? Math.round(lbsProduced / yieldVal) : 0

        const field56 = parseFloat(mylarWeightId.value) || 0;
        const field57 = parseFloat(terplocWeightId.value) || 0;
        const field59 = parseFloat(rhtreatWeightId.value) || 0;
        
        const wasteSavings = (lbsProduced * (field56 + field59 - field57)) / gPerLb;
        
        // Display values
        growFootprint.value = sqftGrow.toLocaleString();
        revenueDisplay.textContent = `${formatNumber(revenue)}`;
        wasteDisplay.textContent = `${formatNumber(wasteSavings)}`;
      }
    
      [price, packaging, output, gramsPerPound, yieldInput].forEach((input) => {
        input.removeEventListener("input", updateValues);
        input.addEventListener("input", updateValues);
      });
    
      updateValues();
    }

    // on submit button show values
    document.getElementById(`envSubmit${index}`).addEventListener('click', function() {
      //console.log(this);
      document.getElementById(`value-text${index}`).classList.add('active');
    });
}

  // Setup first active tab initially
  const firstTab = document.querySelector(".tab-content.active");
  if (firstTab) {
    const tabId = firstTab.id;
    setupInputs(tabId);
  }
  
});


// document.addEventListener("DOMContentLoaded", function () {
//     const tabs = document.querySelectorAll(".tab-title");
//     const contents = document.querySelectorAll(".tab-content");

//     tabs.forEach((tab) => {
//       tab.addEventListener("click", function () {
//         const tabId = this.getAttribute("data-tab-id");

//         tabs.forEach((t) => t.classList.remove("active"));
//         contents.forEach((c) => c.classList.remove("active"));

//         this.classList.add("active");
//         document.getElementById(tabId).classList.add("active");
//       });
//     });

//     const avgPrice = document.getElementById('avgPrice');
//     const packagingPrice = document.getElementById('packagingPrice');
//     const lbsProduced = document.getElementById('lbsProduced');
//     const sqftGrow = document.getElementById('sqftGrow');
//     const yieldInput = document.getElementById('yield');
//     const gramsPerPound = document.getElementById('gramsPerPound');
  
//     const avgPriceValue = document.getElementById('avgPriceValue');
//     const packagingPriceValue = document.getElementById('packagingPriceValue');
//     const lbsProducedValue = document.getElementById('lbsProducedValue');
  
//     const revenueDisplay = document.getElementById('revenue');
//     const wasteDisplay = document.getElementById('waste');
  
//     function formatNumber(num) {
//       return parseFloat(num).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
//     }
  
//     function updateValues() {
//       avgPriceValue.textContent = avgPrice.value;
//       packagingPriceValue.textContent = packagingPrice.value;
//       lbsProducedValue.textContent = parseInt(lbsProduced.value).toLocaleString();
  
//       const pricePerGram = parseFloat(avgPrice.value);
//       const packaging = parseFloat(packagingPrice.value);
//       const pounds = parseFloat(lbsProduced.value);
//       const yieldSqft = parseFloat(yieldInput.value);
//       const grams = parseFloat(gramsPerPound.value);
//       const sqft = parseFloat(sqftGrow.value);
  
//       // Basic mock formula (replace with actual logic as needed)
//       const totalGrams = pounds * grams;
//       const savings = (totalGrams * (packaging / 10)).toFixed(2);
//       const revenue = (totalGrams * (pricePerGram - packaging / 2)).toFixed(2);
  
//       revenueDisplay.textContent = formatNumber(revenue);
//       wasteDisplay.textContent = formatNumber(savings);
//     }
  
//     avgPrice.addEventListener('input', updateValues);
//     packagingPrice.addEventListener('input', updateValues);
//     lbsProduced.addEventListener('input', updateValues);
//     sqftGrow.addEventListener('input', updateValues);
//     yieldInput.addEventListener('input', updateValues);
//     gramsPerPound.addEventListener('input', updateValues);
  
//     updateValues();


  
// });


  

